import { writable } from 'svelte/store';
import { call } from "$lib/Api/Api.svelte";

const nameTypes = writable([]);

const nameTypeStore = {
  subscribe: nameTypes.subscribe,
  load: (id) => {
    return call("name-types", "query")
      .then((data) => {
        nameTypes.set(data);
      })
      .catch((err) => {});
  },
};

export default nameTypeStore;